export default __webpack_public_path__ + "static/media/Gallery8.3dbb2259.jpg";